import { messageDeRefus } from '@/features/distributeur/refus';
import { annoncerVerdict } from '@/shared/utils/verdictEnrolement';

/**
 * « Ajouter un actif » depuis la fiche client. Rend `true` si l'actif est créé (la
 * fenêtre peut se fermer), `false` sinon (elle reste ouverte, la saisie aussi).
 *
 * L'ERREUR ÉTAIT AVALÉE EN CONSOLE. Depuis le lot L2, le serveur refuse en 409 un numéro
 * déjà porté par un autre dossier : sans toast, la fenêtre restait ouverte sans un mot
 * et l'utilisateur croyait à un bug. Le détail du serveur est le message le plus utile.
 *
 * Depuis le lot L4, la fiche chantier du distributeur s'en sert aussi (`url` et
 * `prefixe`) : son ajout interroge l'appareil comme la fiche client, et les deux écrans
 * doivent dire la même chose de la même façon.
 */
export async function ajouterActif({ api, toast, clientId, actif, url, prefixe = 'Actif ajouté' }) {
  try {
    const { data } = await api.post(url || `/clients/${clientId}/assets`,
      { ...actif, puissance_kw: parseFloat(actif.puissance_kw) || 0 });
    annoncerVerdict(toast, prefixe, data?.enrolement);
    return true;
  } catch (err) {
    if (!err?.response) {
      // L'appel a pu aboutir côté serveur avant la coupure : on ne prétend pas le contraire,
      // et l'écran recharge la fiche (voir `handleAddAsset`).
      toast.error('Le serveur n’a pas répondu : l’actif a peut-être été ajouté. Vérifiez la fiche avant de réessayer.',
        { duration: 10000 });
      return false;
    }
    // Un refus peut porter un objet (`{ message, … }`, chantier ambigu côté distributeur) :
    // une seule lecture du refus pour toute l'application (`messageDeRefus`).
    const message = messageDeRefus(err, null);
    toast.error(typeof message === 'string' && message ? message
      : "L'actif n'a pas été ajouté. Vérifiez la saisie puis réessayez.");
    return false;
  }
}
